export default __webpack_public_path__ + "static/road-station-3d5c804e3a05f26e930a11f9e3c11463.png";